import {Observable, of, map, merge,  filter} from 'rxjs';
import {Router, NavigationEnd, Event} from '@angular/router';
import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
	name: 'isRouteActive',
	standalone: true,
	pure: true,
})
export class IsRouteActivePipe implements PipeTransform {

	public isActive(path: string): boolean {
		return this._router.isActive(
			path,
			{
				matrixParams: 'ignored',
				queryParams: 'ignored',
				paths: 'subset',
				fragment: 'ignored',
			}
		);
	}

	public transform(path: string): Observable<boolean> {

		if (!path) {

			return of(false);
		}

		return merge(
			this._router.events.pipe(
				filter((evt: Event) => evt instanceof NavigationEnd),
				map((_) => this.isActive(path)),
			),
			of(this.isActive(path)),
		);
	}

	constructor(
		private _router: Router,
	
	) {}
}
